import { Job } from '@core/generated/gql-types';
import {
  TemplateTerm,
  useTemplateStore,
} from '@core/template/useTemplateStore';
import WorkerSearchbar from './workerSearchbar/WorkerSearchbar';

interface AssignJobWorkersProps {
  job: Job;
  openWorkerSearchModal: boolean;
  setLoading: (loading: boolean) => void;
  setOpenWorkerSearchModal: (open: boolean) => void;
}

const AssignJobWorkers = ({
  job,
  openWorkerSearchModal,
  setLoading,
  setOpenWorkerSearchModal,
}: AssignJobWorkersProps) => {
  const { getTerm } = useTemplateStore();

  if (!openWorkerSearchModal) {
    return (
      <div className="flex h-12 w-full items-center justify-between gap-2 rounded-md bg-white p-2">
        <div className="flex items-center gap-2">
          <div className="pl-3 text-sm text-gray-600">
            No {getTerm(TemplateTerm.WORKER, false)} assigned
          </div>
        </div>
      </div>
    );
  }

  return (
    <WorkerSearchbar
      job={job}
      setLoading={setLoading}
      setOpenWorkerSearchModal={setOpenWorkerSearchModal}
    />
  );
};

export default AssignJobWorkers;
